module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAApUlEQVQ4jZWTQQrEIAwAQ/GwjytlWfq/UvbQN0oP04OxK5poN+DFOBOJRkREgABswEcGAazADoS8EYCDFCewDuBTzx5AEK1chimp4By7ADMQexIHjsCcD7iSIVxU8SRjeCB5Bj+QmPBkOF7O/qS5bnWrYU1j/4GtJrYSB47AW5f/TzrwUhRYXAlpMGq46Tb263zrYeq+cyVJw6SJoDfpf5Kf5B7nCxTFZsehfWOmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/close.png
// module id = 175
// module chunks = 0